import React, { useEffect, useMemo, useRef, useState } from "react";

function customerLabel(customer) {
  if (!customer) return "";
  return customer.name || "Tenant";
}

function CustomerSearchSelect({
  customers = [],
  value,
  onChange,
  placeholder = "Select tenant receiving the lead",
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const rootRef = useRef(null);

  const selected = useMemo(
    () => customers.find((customer) => String(customer.id) === String(value)),
    [customers, value]
  );

  const filteredCustomers = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return customers.slice(0, 100);
    return customers
      .filter((customer) => String(customer.name || "").toLowerCase().includes(query))
      .slice(0, 100);
  }, [customers, search]);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const selectCustomer = (customer) => {
    onChange?.(String(customer.id));
    setOpen(false);
    setSearch("");
  };

  return (
    <div ref={rootRef} style={{ position: "relative", width: "100%" }}>
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        aria-haspopup="listbox"
        aria-expanded={open}
        style={{
          width: "100%",
          minHeight: 42,
          padding: "10px 12px",
          textAlign: "left",
          background: "#fff",
          border: "1px solid #d1d5db",
          borderRadius: 4,
          cursor: "pointer",
        }}
      >
        {selected ? customerLabel(selected) : `— ${placeholder} —`}
      </button>

      {open && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            zIndex: 1000,
            padding: 8,
            background: "#fff",
            border: "1px solid #d1d5db",
            borderRadius: 4,
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.14)",
          }}
        >
          <input
            type="text"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search by name..."
            autoFocus
            style={{ width: "100%", marginBottom: 8 }}
          />
          <div style={{ maxHeight: 240, overflowY: "auto" }}>
            {filteredCustomers.length > 0 ? (
              filteredCustomers.map((customer) => (
                <button
                  key={customer.id}
                  type="button"
                  role="option"
                  aria-selected={String(customer.id) === String(value)}
                  onClick={() => selectCustomer(customer)}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "9px 10px",
                    textAlign: "left",
                    border: 0,
                    borderRadius: 3,
                    background:
                      String(customer.id) === String(value) ? "#eff6ff" : "#fff",
                    cursor: "pointer",
                  }}
                >
                  {customerLabel(customer)}
                </button>
              ))
            ) : (
              <div style={{ padding: 10, color: "#6b7280" }}>
                No customers found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerSearchSelect;
